<template>
  <div>
    <div class="header mb-4" :class="mobile_menu_open && should_show_mobile_menu ? 'header--mobile-menu-open' : ''">
      <div class="container">
        <div class="row py-1 py-sm-0 align-items-center nav text-right text-md-center flex-nowrap">
          <router-link class="col logo-container" to="/">
            <div class="logo d-flex align-items-center">
              <img src="../assets/pytrace-256.png" class="mr-2 logo__image" width="41" height="41" alt="logo"/>
              <span class="logo__text">PyTrace</span>
            </div>
          </router-link>
          <router-link v-if="!should_show_mobile_menu" class="ml-4 col nav__link nav__link--home" to="/">
            <div>
              Home
            </div>
          </router-link>
          <router-link v-if="!should_show_mobile_menu" class="col nav__link" to="/docs">
            <div>
              Documentation
            </div>
          </router-link>
          <a :href="webAppLink" v-if="!should_show_mobile_menu" class="col  nav__link">
            <div>
              Open App
            </div>
          </a>

          <a href="https://pycrunch.com/donate" target="_blank" class="col" v-if="!should_show_mobile_menu"  >
            <div>
              <el-button class="nav__button" >
                Donate
              </el-button>
            </div>
          </a>

          <div class="col text-right" @click="show_mobile_menu()" v-if="should_show_mobile_menu">
            <transition name="fade2"  mode="out-in">
              <img class="mobile-menu-open" v-if="!mobile_menu_open" src="../assets/mobile_menu.svg" alt="mobile-menu"/>
              <img class="mobile-menu-close" v-if="mobile_menu_open" src="../assets/menu_cross.svg" alt="m-close"/>
            </transition>
          </div>

        </div>
      </div>
    </div>
<!--    Mobile menu (fullscreen) start-->
    <transition name="fade">
      <div class="mobile-menu-surface mt-n4 position-fixed" v-show="mobile_menu_open" v-if="should_show_mobile_menu">
      <div class="container">
        <div class="row flex-column text-left ml-4 pt-4">
          <router-link v-if="should_show_mobile_menu" class="col nav__link nav__link--mobile nav__link--home" to="/">
            <div>
              Home
            </div>
          </router-link>
          <router-link v-if="should_show_mobile_menu" class="col nav__link nav__link--mobile" to="/docs">
            <div>
              Documentation
            </div>
          </router-link>
          <a :href="webAppLink" v-if="should_show_mobile_menu" class="col  nav__link nav__link--mobile">
            <div>
              Open App
            </div>
          </a>

          <a href="https://pycrunch.com/donate" target="_blank" class="col p-0 pr-4 mt-4" v-if="should_show_mobile_menu">
            <div>
              <el-button class="mobile-menu__button">
                Donate
              </el-button>
            </div>
          </a>
        </div>
      </div>
    </div>
    </transition>
      <!--    Mobile menu (fullscreen) end-->

  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import config from '../config'

  export default {
    name: 'pc-header',
    props: ['activeIndex'],
    data () {
      let x = this.determineMenuOrientation()
      return {
        should_show_mobile_menu: x,
        mobile_menu_open: false,
        webAppLink: config.webapp_link,

        // activeIndex: '1',
      }
    },
    mounted () {
      this.toggleBodyClass('remove', 'overflow-hidden')
      let self = this
      window.addEventListener('resize', self.invalidateResponsiveMenu)
      setTimeout(() => this.invalidateResponsiveMenu(), 100)
    },
    methods: {
      show_mobile_menu () {
        this.mobile_menu_open = !this.mobile_menu_open
        if (this.mobile_menu_open) {
          window.scrollTo(0, 0);
          this.toggleBodyClass('add', 'overflow-hidden')
        } else {
          this.toggleBodyClass('remove', 'overflow-hidden')
        }
      },
      determineMenuOrientation: function () {
        let x = false
        x = window.innerWidth < 769
        return x
      },
      invalidateResponsiveMenu () {
        console.log('invalidateResponsiveMenu')
        console.log(window.innerWidth)
        let x = this.determineMenuOrientation()
        this.should_show_mobile_menu = x

      },
      toggleBodyClass(addOrRemoveClass, className) {
        const el = document.body;

        if (addOrRemoveClass === 'add') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    updated () {
      this.invalidateResponsiveMenu()
    },

    destroyed () {
      window.removeEventListener('resize', self.invalidateResponsiveMenu)
    },
    computed: {
      ...mapState(['is_logged_in']),
    },
  }
</script>

<style scoped>
  .logo__text {
    font-family: PT Sans, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 1.7em;
    color: #000000;
    transition: color 200ms ease-in;
  }

  .header {
    background-color: #ffffff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.23);
    font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
    transition: background-color 70ms ease-in;
    will-change: background-color;
  }

  .header--mobile-menu-open {
    background-color: #1A1A1A;

  }

  .header--mobile-menu-open .logo__text {
    color: #FFFFFF;

  }

  .nav__link {
    color: #000000;
    /*height: 3em;*/
    padding: 1em 0;
  }

  .nav__link.router-link-active {
    font-weight: 700;
    border-bottom: 2px solid #42b983;
  }
  .nav__link.nav__link--home.router-link-active {
    font-weight: normal;
    border-bottom: none;
  }
  .nav__link.nav__link--home.router-link-exact-active {
    font-weight: 700;
    border-bottom: 2px solid #42b983;
  }

  .logo-container {
    text-decoration: none;
  }

  .mobile-menu {
    cursor: pointer;
  }

  .mobile-menu-surface {
    top: 4.4em;
    left: 0;
    width: 100%;
    z-index: 1200 ;
    height: 100%;
    background-color: rgba(54, 54, 54, 0.98);

  }
  .nav__link.nav__link--mobile.router-link-exact-active {
    border-bottom: none;
    color: #ffffff;

  }
  .nav__link.nav__link--mobile.router-link-active {
    border-bottom: none;
    color: #ffffff;
  }
  .nav__link.nav__link--mobile.nav__link--home.router-link-active {
    font-weight: normal;
  }
  .nav__link.nav__link--mobile.nav__link--home.router-link-exact-active {
    font-weight: 700;
  }


  .nav__link--mobile {
    color: #fbfcfc;
  }

  .mobile-menu__button {
    background-color: rgb(101, 152, 0);
    color: #ffffff;
    border: none;
    box-shadow: 0 0 6px rgba(81, 122, 0, 0.32);
    font-weight: 700;
    width: 100%;
    font-size: 1.3em;
  }

  .mobile-menu__button:hover {
    background-color: #448406;
    color: #ffffff;

  }

  @media (max-width: 991px) {
    .nav__link {
      font-size: 0.7em;
    }
    .nav__link.nav__link--mobile {
      font-size: 1.1em;
    }
    .logo__image {
      width: 32px;
      height: 32px;
    }
    .nav__button {
      padding: 0.5em 1em;
    }
  }

  @media (max-width: 769px) {
    .mobile-menu-surface {
      top: 4em;
    }
  }
  @media (max-width: 576px) {
    .mobile-menu-surface {
      top: 4.4em;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 345.5ms
    cubic-bezier(0.32, 0.08, 0.24, 1) 20ms,
    transform 0s cubic-bezier(0.32, 0.08, 0.24, 1),
    -webkit-transform 0s cubic-bezier(0.32, 0.08, 0.24, 1);
    /*transition: opacity 300ms;*/
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }

  .fade2-enter-active, .fade2-leave-active {
    /*transition: opacity 345.5ms*/
    /*cubic-bezier(0.32, 0.08, 0.24, 1) 20ms,*/
    /*transform 0s cubic-bezier(0.32, 0.08, 0.24, 1),*/
    /*-webkit-transform 0s cubic-bezier(0.32, 0.08, 0.24, 1);*/
    transition: opacity 300ms;
  }
  .fade2-enter, .fade2-leave-to  {
    opacity: 0;
  }
</style>